"use strict";

var e = require("./_rollupPluginBabelHelpers-47e7ccca.js"),
    n = require("react"),
    t = require("prop-types"),
    o = require("styled-components"),
    r = require("./constants-79aa80eb.js");

function i(e) {
  return e && "object" == typeof e && "default" in e ? e : {
    default: e
  };
}

var s,
    a = i(n),
    l = i(t),
    p = i(o).default.div(s || (s = e._taggedTemplateLiteral(["\n  height: 0;\n  max-width: 200px;\n  position: absolute;\n  right: 8px;\n  top: 9px;\n  transition: all .3s ease-in-out;\n  width: 100%;\n  ", "\n\n  .icone--tooltip {\n    float: right;\n    height: 15px;\n    width: 15px;\n  }\n\n  .icone--tooltip:hover + p {\n    transform: translate(50%, -140%);\n    visibility: visible;\n  }\n\n  .icone--tooltip p {\n    align-items: center;\n    border: 1px solid ", ";\n    border-radius: 100%;\n    color: ", ";\n    cursor: pointer;\n    display: flex;\n    ", "\n    font-size: 11px;\n    font-weight: bold;\n    height: 100%;\n    justify-content: center;\n    line-height: 0;\n    margin: 0;\n    width: 100%;\n  }\n\n  .mensagem--tooltip {\n    background-color: ", ";\n    border-radius: 10px;\n    color: ", ";\n    ", "\n    font-size: 12px;\n    margin: 0;\n    padding: 7px 14px;\n    pointer-events: none;\n    position: absolute;\n    right: 8px;\n    top: 0;\n    transform: translate(50%, -50%);\n    transition: transform .2s ease-in-out, visibility .1s ease-in-out;\n    visibility: hidden;\n  }\n\n  .mensagem--tooltip:after {\n    border-color: ", " transparent transparent transparent;\n    border-style: solid;\n    border-width: 5px;\n    content: '';\n    left: 50%;\n    margin-left: -5px;\n    position: absolute;\n    top: 100%;\n  }\n"])), function (e) {
  return (e.erro || e.sucesso || e.select) && "\n  transform: translate(-25px, 0);\n";
}, r.cores.cinza300, r.cores.cinza500, r.defaultFonte, r.cores.cinza200, r.cores.cinza500, r.defaultFonte, r.cores.cinza200),
    c = function c(e) {
  var n = e.mensagem,
      t = e.erro,
      o = e.select,
      r = e.sucesso;
  return a.default.createElement(p, {
    className: "tooltip",
    erro: t,
    select: o,
    sucesso: r
  }, a.default.createElement("div", {
    className: "icone--tooltip"
  }, a.default.createElement("p", null, "?")), a.default.createElement("p", {
    className: "mensagem--tooltip"
  }, n));
};

c.propTypes = {
  erro: l.default.bool.isRequired,
  mensagem: l.default.string.isRequired,
  select: l.default.bool,
  sucesso: l.default.bool.isRequired
}, c.defaultProps = {
  erro: !1,
  mensagem: "",
  select: !1,
  sucesso: !1
}, module.exports = c;